export default __webpack_public_path__ + "static/media/fridge2-beforeA-1440w.430721c6.webp";